import { scheduledTransactionsSelectors } from 'app-components/flux/scheduled-transactions';
import store from 'app-components/utils/redux-store';

import { getBillerAccountsForLoginId } from './billerAccountsSelectors';

export const getConnectedAccounts = (id) => {
  const state = store.getState();
  const scheduledTxns = scheduledTransactionsSelectors.getScheduledTransactions(state);
  const currentAccounts = getBillerAccountsForLoginId(state, id);

  return currentAccounts.filter((account) =>
    scheduledTxns.find((model) => model.billPresentmentAccountId === account.id),
  );
};
